import { observer } from "mobx-react";
import React, { useContext, useEffect } from "react";
import { Cubby, CubbyContext } from "./stores/Cubby";
import {
  Button,
  Paper,
  Textarea,
  List,
  Divider,
  Stack,
  Image,
  Box,
  Anchor,
  Flex,
  Group,
  Center,
  Alert,
  Portal,
} from "@mantine/core"; // Import Portal
import { Title, Text } from "@mantine/core";

import JsonViewer from "./cubbyComponents/jsonView";
import { startAccountsActionCable } from "./helpers/actionCable";

import ChannelsList from "./cubbyComponents/channelsList";

import AllModals from "./cubbyComponents/AllModals";
import LesserButtons from "./cubbyComponents/lesserButtons";

import Balances from "./cubbyComponents/dataDisplay/balances";

import SomeButtons from "./cubbyComponents/someButtons";
import Tasks from "./cubbyComponents/tasks"; // Tasks handles notifications
import StartAndStatus from "./cubbyComponents/interactiveData/startAndStatus";
import Disclaimers from "./cubbyComponents/disclaimers";
import IdleTimer from "./cubbyComponents/idleTimer";
import { IconAlertTriangle } from "@tabler/icons-react";
import YouHaveBeenDisconnected from "./cubbyComponents/youHaveBeenDisconnected";
import DocsFooter from "./docs/docsFooter";
import Ledger from "./cubbyComponents/ledger";

const CubbyContainer: React.FC = observer(() => {
  const cubby = useContext<Cubby>(CubbyContext);

  useEffect(() => {
    cubby.hydrateDataFromPage();
    startAccountsActionCable(cubby, null);
  }, []);

  return (
    <>
      {cubby.userHasGoneIdle && <YouHaveBeenDisconnected cubby={cubby} />}

      {!cubby.userHasGoneIdle && cubby.hasLoaded && (
        <>
          <Stack>
            <IdleTimer cubby={cubby} />
            <StartAndStatus cubby={cubby} />
            <Balances cubby={cubby} />

            <SomeButtons cubby={cubby} />
            <Divider my="xs" />
            <ChannelsList cubby={cubby} />

            <LesserButtons cubby={cubby} />

            <Ledger cubby={cubby} />
            <Disclaimers cubby={cubby} />
            <JsonViewer cubby={cubby} />
            <AllModals cubby={cubby} />
            <DocsFooter />
          </Stack>

          {/* Tasks with notifications rendered in a Portal */}
          <Portal>
            <Tasks cubby={cubby} />
          </Portal>
        </>
      )}
    </>
  );
});

export default CubbyContainer;
